// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import VueResource from 'vue-resource'

Vue.use(VueResource)
Vue.use(BootstrapVue)
Vue.config.productionTip = false

// Set baseurl
let baseUrl = ''

if (process.env.NODE_ENV === 'production') {
    baseUrl = '/'
} else {
    baseUrl = 'http://localhost/projecten/hak4t-survey'
}
Vue.http.options.root = baseUrl

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    template: '<App/>',
    components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js